//全屏（兼容不同浏览器）
function fullScreenOper(el) {
    let rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullScreen,
        wscript;
    if (typeof rfs != "undefined" && rfs) {
        rfs.call(el);
        return;
    }
    if (typeof window.ActiveXObject != "undefined") {
        wscript = new ActiveXObject("WScript.Shell");
        if (wscript) {
            wscript.SendKeys("{F11}");
        }
    }
}

//判断是否已全屏（兼容不同浏览器）
function isFullscreen() {
    return document.fullscreenElement ||
        document.msFullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement || false;
}

//监听全屏切换触发的事件（兼容不同浏览器）
function addScreenListener(fullScreenChange) {
    ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange'].forEach((item, index) => {
        document.addEventListener(item, () => fullScreenChange());
    })
}

export {addScreenListener, fullScreenOper, isFullscreen}